import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sponsor-results',
  templateUrl: './sponsor-results.component.html',
  styleUrls: ['./sponsor-results.component.scss']
})
export class SponsorResultsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
